export function replaceImgTag(html, target = "[图片]") {
    if (html) {
        return html.replace(/<img[^>]*>/g, target)
    } else {
        return html;
    }
}
